const Footer: React.FC = () => {
	return (
		<section id="testimonials" className="section testimonials no-padding">
			<div className="container-fluid">
				<div className="row no-gutter">
					<div className="col-md-12">
						<div><a href="/" >整形外科診断ツールのホームへ戻るときはこちらをクリック</a></div>
					</div>
				</div>
			</div>
			<div className="pt-2"><p>&copy; 2021 整形外科診断ツール</p></div>
		</section>
	);
};

export { Footer };

